<template>
  <b-container class="communes">
    <div>
      <div class="row">
        <div class="div_img col-12">
          <a href="https://www.linggo.fr">
            <img class="logo_desktop" src="../assets/logo.png" alt="logo langres"/>
          </a>
        </div>
      </div>
    </div>

    <h1 class="titre">Prochains passages</h1>
    <h2 class="selection_arret">Sélectionnez l'arrêt de votre choix :</h2>
    <div class="div_loader" v-if="loading">
      <b-spinner class="loader" type="grow" label="Spinning"></b-spinner>
    </div>
    <div class="liste_arret row">
      <div v-for="stopName in listStopsNames" :key="stopName" class="col-lg-3 col-md-4 col-12">
        <b-btn :to="{name: 'ProchainPassage', params: {stopName: stopName}}" class="arret">
          <span class="nom_arret">{{ stopName }}</span>
        </b-btn>
      </div>
    </div>
  </b-container>
</template>

<script>
export default {
  name: 'Arrets',
  data () {
    return {
      listStopsNames: null,
      loading: false
    }
  },
  mounted () {
    this.loading = true
    this.axios.get('/listStops')
      .then((succes) => {
        this.listStopsNames = succes.data
        this.loading = false
      }, (error) => {
        console.error('ERREUR', error.body)
      })
  }
}
</script>

<style lang="scss">
@import "../sass/variables";
@import "../../node_modules/bootstrap/scss/bootstrap";

.communes {
  text-align: center;
  margin-bottom: 2rem;

  .div_img {
    display: flex;
    margin-top: 2rem;
    margin-bottom: 2rem;

    a {
      margin: auto;

      .logo_desktop {
        width: 100%;
        max-width: 300px;
        padding: 1rem;
      }
    }
  }

  .titre {
    color: $secondcolor;
    font-family: $linggofont;
    font-size: 40px;
    margin-bottom: 2rem;
  }

  .selection_arret {
    color: $secondcolor;
    font-family: $linggofont;
    font-size: 35px;
  }

  .div_loader {
    display: flex;
    margin: 4rem 0;
    @include media-breakpoint-up(sm) {
      height: 0;
    }

    .loader {
      margin: auto;
      color: $secondcolor;
      width: 6rem;
      height: 6rem;
    }
  }

  .liste_arret {
    justify-content: center;
    margin-top: 2rem;
    display: flex;

    .arret {
      height: 100px;
      border: 2px solid $firstcolor;
      background-color: white;
      border-radius: 10px;
      font-family: $linggofont;
      color: $firstcolor;
      font-size: 20px;
      margin: 15px 0;
      padding: 1rem;
      text-decoration: none;
      display: flex;
      @include media-breakpoint-between(md, lg) {
        height: 125px;
      }

      .nom_arret {
        margin: auto;
        text-transform: uppercase;
      }
    }

    .arret:hover {
      background-color: $firstcolor;
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue